import { FormControl, StyledSelect, Label } from "../../Form/FormControls";
import ErrorMessages from "../../Notifications/ErrorMessages";

const SearchSelect = ({
  label,
  placeholder,
  options,
  selectedOption,
  onChange,
  inputValue,
  onInputChange,
  loading,
  error,
  warning, // <- added
  isMulti,
}) => (
  <FormControl style={{ minWidth: "300px" }}>
    <Label>{label}</Label>
    {warning && (
      <div
        style={{
          marginBottom: "2px",
          color: "#cc3300",
          fontSize: "0.9rem",
        }}
      >
        Please enter at least 2 characters to search.
      </div>
    )}
    <StyledSelect
      className={`react-select-container`}
      classNamePrefix={`react-select`}
      name={label}
      id={`${label.toLowerCase().replace(/\s+/g, "-")}`}
      inputId={`${label.toLowerCase().replace(/\s+/g, "-")}-input`}
      instanceId={`${label.toLowerCase().replace(/\s+/g, "-")}-instance`}
      options={options}
      placeholder={placeholder}
      value={selectedOption}
      isLoading={loading}
      onChange={onChange}
      inputValue={inputValue}
      onInputChange={onInputChange}
      menuPlacement="auto"
      menuPortalTarget={document.body}
      {...(isMulti ? { isMulti: true } : {})}
    />
    {error && <ErrorMessages errors={error} />}
  </FormControl>
);

export default SearchSelect;
